import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";


import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

import Counters from "pages/Presentation/sections/Counters";
import Information from "pages/Presentation/sections/Information";
import Pages from "pages/Presentation/sections/Pages";
import Testimonials from "pages/Presentation/sections/Testimonials";

// Presentation page components
import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/bg.jpg";

function Presentation() {
  return (
    <>
      <DefaultNavbar
        routes={routes}
        sticky
      />
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="white"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              RO Informational{" "}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="white"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              Discover the innovative technologies developed by our organization, including cutting-edge tools, software, and methodologies.
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Counters />
        <Information />
        <Pages />
        <Container sx={{ mt: 6 }}>
          <BuiltByDevelopers />
        </Container>
        <Container>
<Container>
  <Grid container spacing={3}>
    <Grid item xs={12} sm={6} lg={4}>
      <FilledInfoCard
        variant="gradient"
        color="info"
        icon="science"
        title="Research Areas"
        description="Explore our diverse fields of study, from environmental science to artificial intelligence, and see how our research is addressing global challenges."
        action={{
          type: "external",
          route: "#",
          label: "Discover More",
        }}
        sx={{
          height: '100%',
          transition: 'transform 0.3s, box-shadow 0.3s',
          '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: '0 12px 20px -10px rgba(0,0,0,0.2)',
          },
        }}
      />
    </Grid>
    <Grid item xs={12} sm={6} lg={4}>
      <FilledInfoCard
        color="info"
        icon="biotech"
        title="Facilities & Resources"
        description="Learn about our state-of-the-art laboratories, advanced equipment, and extensive databases that support our cutting-edge research."
        action={{
          type: "external",
          route: "#",
          label: "View Facilities",
        }}
        sx={{
          height: '100%',
          transition: 'transform 0.3s, box-shadow 0.3s',
          '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: '0 12px 20px -10px rgba(0,0,0,0.2)',
          },
        }}
      />
    </Grid>
    <Grid item xs={12} sm={6} lg={4}>
      <FilledInfoCard
        color="info"
        icon="groups"
        title="Collaborations"
        description="Discover our network of partnerships with universities, industry leaders, and government agencies that enhance the scope and impact of our research."
        action={{
          type: "external",
          route: "#",
          label: "Our Partners",
        }}
        sx={{
          height: '100%',
          transition: 'transform 0.3s, box-shadow 0.3s',
          '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: '0 12px 20px -10px rgba(0,0,0,0.2)',
          },
        }}
      />
    </Grid>
  </Grid>
</Container>
</Container>
        <Testimonials />    
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Presentation;
